import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

const Organization = (props) => (
      <div className="organization-row">
        <div className="organization-text">
          	<h5 className="organization__type">{props.information.type_name}</h5>
            <div className="organization">
                <Address information={props.information}/>
          	    <ContactInfo information={props.information}/>
                {props.information.type==="community" &&
                    <LinkToCongregations
                        information={props.information}
                        children={props.information.childrenCount} />}
            </div>
            <div className="inFeedInfo"><p>Med i feed: {props.information.is_public ? <span>Ja</span> : <span style={{color: '#800E30', fontWeight: 'bold'}}>Nej</span>}</p></div>
          </div>
        {!props.hideEditLink && <EditLink hideEditLink={props.EditLink} id={props.information.id} />}
      </div>
);

const EditLink = (props) => (
            <div className="organization-button">
                <img src="/images/assets/pil.svg" alt="" width="44" height="178" />
                <Link to={'/admin/organization/' + props.id + '/edit'} className="itemLink"> </Link>
            </div>
)

const Address = (props) => (
		<div className="address">
			<div className="address__header">{props.information.name}</div>
			<div>{props.information.address}</div>
			<div>{props.information.zip_code + ' ' + props.information.city}</div>
			<div>CVR nr. {props.information.vat_number}</div>
		</div>
);

const ContactInfo = (props) => (
    <div className="contactInfo">
    	<div className="contactInfo__header">Kontaktoplysninger</div>
    	<div>Navn: {props.information.contact_name}</div>
    	<div>E-mail: {props.information.contact_email}</div>
    	<div>Tlf.: {props.information.contact_phone}</div>
    </div>
);

const buttonStyle = {
    position: "relative",
    zIndex: "101",
    width: "100px",
    padding: "0",
    border: "1px solid #15a6b2"
};

const LinkToCongregations = (props) => (
    <div className="attachedOrganizations">
        {props.children>0 ?
            <Link to={'/admin/organization/' + props.information.id + '/edit#menigheder'} className="button" style={buttonStyle}>Vis tilknyttede menigheder</Link> : ''}
    </div>
);

export default Organization;


// WEBPACK FOOTER //
// ./src/modules/organization/Item.js